import { Link } from 'react-router-dom';
import CorrectionCaseLog from './CorrectionCaseLog';

export default function AccountingHistorySection({
  stats,
  cases,
  casesPagination,
  caseFilter,
  onCaseFilterChange,
  onLoadCases,
  fixes,
  loadingHistory,
  historyError,
  onRetryLoad,
  selectedCase,
  onOpenCase,
  onCloseCase,
  onRevertCase,
  reverting,
}) {
  if (loadingHistory && cases.length === 0) {
    return (
      <div className="admin-panel">
        <p className="small text-muted mb-0">Loading audit trail for this pump…</p>
      </div>
    );
  }

  if (historyError && cases.length === 0) {
    return (
      <div className="admin-alert-item warning">
        <strong>Could not load audit trail</strong>
        <p className="small mb-2">{historyError}</p>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={onRetryLoad}>Retry</button>
      </div>
    );
  }

  return (
    <>
      <div className="admin-panel">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div>
            <h5 className="mb-1">Audit trail</h5>
            <p className="small text-muted mb-0">
              Permanent record of every correction — user, timestamp, reason, and row-level before/after values.
            </p>
          </div>
          <Link to="/admin-audit-log" className="small">Full platform audit log →</Link>
        </div>

        {stats && (
          <div className="accounting-health-grid mb-3">
            <div className="accounting-metric-card"><span className="small text-muted">Total fixes applied</span><strong>{stats.total_cases}</strong></div>
            <div className="accounting-metric-card"><span className="small text-muted">Rows updated</span><strong>{stats.total_rows_affected}</strong></div>
            <div className="accounting-metric-card"><span className="small text-muted">Passed re-check</span><strong>{stats.verified_ok_count}</strong></div>
          </div>
        )}

        <div className="row g-2 mb-3">
          <div className="col-md-4">
            <select
              className="form-select form-select-sm"
              value={caseFilter}
              onChange={(e) => onCaseFilterChange(e.target.value)}
            >
              <option value="">All fix types</option>
              {fixes.map((f) => (
                <option key={f.fix_type} value={f.fix_type}>{f.plain_label || f.label}</option>
              ))}
            </select>
          </div>
        </div>

        {cases.length === 0 ? (
          <p className="small text-muted">No fixes have been applied yet for this pump.</p>
        ) : (
          <div className="table-responsive">
            <table className="table admin-pump-table">
              <thead>
                <tr><th>Date</th><th>Fix</th><th>Applied by</th><th>Status</th><th>Reason</th><th>Rows</th><th>Re-check</th><th /></tr>
              </thead>
              <tbody>
                {cases.map((row) => (
                  <tr key={row.id}>
                    <td className="small">{row.applied_at || row.created_at}</td>
                    <td className="small">{row.fix_label}</td>
                    <td className="small">{row.applied_by_name || row.created_by_name || '—'}</td>
                    <td className="small">
                      {row.is_reverted ? 'Undone' : row.status === 'applied' ? 'Applied' : row.status}
                    </td>
                    <td className="small text-truncate" style={{ maxWidth: 220 }}>{row.apply_reason}</td>
                    <td>{row.rows_affected}</td>
                    <td>{row.verification_ok === true ? '✓ OK' : row.verification_ok === false ? '✗ Issues remain' : '—'}</td>
                    <td className="text-nowrap">
                      <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => onOpenCase(row.id)}>Details</button>
                      {row.can_revert && (
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => onOpenCase(row.id)}>Undo</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {casesPagination.last_page > 1 && (
          <div className="d-flex gap-2 mt-2">
            {Array.from({ length: casesPagination.last_page }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                type="button"
                className={`btn btn-sm ${p === casesPagination.current_page ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => onLoadCases(p)}
              >
                {p}
              </button>
            ))}
          </div>
        )}
      </div>

      {selectedCase && (
        <CorrectionCaseLog
          caseRecord={selectedCase}
          onClose={onCloseCase}
          onRevert={onRevertCase}
          reverting={reverting}
        />
      )}
    </>
  );
}
